import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FilesEndpointsEnum } from "@environments/apis/files.api";
import { map } from "rxjs/operators";
import { FsUserInterface } from "@modules/filesystem/interfaces/fs-user.interface";
import { ApiService } from "@core/services/api.service";
import { IdRoleInterface } from "@core/models/id/id-role.interface";
import { HttpContext } from '@angular/common/http';

@Injectable({
  providedIn: "root",
})
export class FilesystemApiService {
  readonly #apiService = inject(ApiService);

  getSelfRoles(context?: HttpContext): Observable<IdRoleInterface[]> {
    return this.#apiService.get("files", FilesEndpointsEnum.GET_SELF, {context}).pipe(
      map((response: { user: FsUserInterface }) => {
        return response.user.roles ?? []
      })
    );
  }
}
